module.exports = __webpack_public_path__ + "static/media/26.b54f3854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/26.jpg
// module id = 287
// module chunks = 0